import * as React from 'react';

import handleThrottling from '../functions/handleThrottling';

/**
 * `useBoundingClientRect` returns a DOMRect object providing information about
 * the size of an element and its position relative to the viewport.
 *
 * react-hooks/exhaustive-deps is disabled on the useEffect
 * dependencies because useEffect should only update on `ref`
 * or on initial load.
 */
export default function useBoundingClientRect(ref) {
  const [boundingClientRect, setBoundingClientRect] = React.useState({});

  const setBoundingClientRectHandler = () => {
    if (ref && ref.current) setBoundingClientRect(ref.current.getBoundingClientRect());
  };

  React.useEffect(() => {
    setBoundingClientRectHandler();
  }, [ref]);

  React.useEffect(() => {
    window.addEventListener('resize', handleThrottling(setBoundingClientRectHandler, 110));

    return () => window.removeEventListener('resize', setBoundingClientRectHandler);
  }, []);

  return boundingClientRect;
}
